import React, { PropsWithChildren } from 'react';
import {
  Box,
  IconButton,
} from '@mui/material';
import { Close } from '@mui/icons-material';

interface DynamicFormProps {
  editing?: boolean;
  onEditing?: () => void;
}

export const RemovableField: React.FC<PropsWithChildren<DynamicFormProps>> = ({ children, editing, onEditing }) => (
   
  <Box
    display="flex"
    justifyContent="space-between"
    alignItems="center"
    gap={1}
  >
    {children}
    {editing && (
      <IconButton 
        sx={{ width: 40, height: 40, mt: 1 }}
        onClick={() => onEditing?.()}
      >
        <Close color="error" />
      </IconButton>
    )}
  </Box>
);
